import { IsDefined, ValidateNested } from 'class-validator';

import { Address } from '../address/address';

export class GetDeliveryDistanceRequest {
    @IsDefined()
    @ValidateNested()
    public addressFrom: Address;

    @IsDefined()
    @ValidateNested()
    public addressTo: Address;

    constructor(data?: Partial<GetDeliveryDistanceRequest>) {
        this.addressFrom = data?.addressFrom ? new Address(data.addressFrom) : undefined;
        this.addressTo = data?.addressTo ? new Address(data.addressTo) : undefined;
    }
}
